<script lang="ts">
    import { resolve, tgettext } from 'hydria/services/gettext'

    import { type ISchemeDef, SCHEMES } from '../models'

    interface Props {
        id: string | null | undefined
    }

    let { id }: Props = $props()

    const UNSET: ISchemeDef = {
        id: 'unset',
        text: tgettext('Non-configuré'),
        textClass: 'text-warning',
    }

    let scheme: ISchemeDef = $derived(SCHEMES.filter((s) => s.id == id)[0] || UNSET)
</script>

<style>
    .inner {
        display: flex;
        flex-direction: column;
        gap: 0.15rem;
        /* padding: 0.5rem; */
        margin: 0 calc(var(--bs-btn-padding-x));
        padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
    }
    .scheme {
        border: 1px solid var(--bs-border-color);
        border-radius: var(--bs-border-radius-sm);
    }
    .fake-title {
        height: 0.5rem;
        width: 35%;
        background-color: var(--sc-title-color);
        border-radius: var(--bs-border-radius-sm);
    }
    .fake-text {
        height: 0.25rem;
        width: 100%;
        background-color: var(--sc-text-color);
        border-radius: var(--bs-border-radius-sm);
    }
    .fake-text:last-child {
        width: 57%;
    }
</style>

<div class="scheme scheme-{id} outer">
    <div class="inner">
        <div class="fake-title"></div>
        <div class="fake-text"></div>
        <div class="fake-text"></div>
    </div>
</div>
<div class="description {scheme.textClass ? scheme.textClass : ''}">{$resolve(scheme.text)}</div>
